import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "21",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M6.5 1.75V3h5V1.75c0-.664.547-1.25 1.25-1.25.664 0 1.25.586 1.25 1.25V3h1.875c1.016 0 1.875.86 1.875 1.875V6.75H.25V4.875C.25 3.859 1.07 3 2.125 3H4V1.75C4 1.086 4.547.5 5.25.5c.664 0 1.25.586 1.25 1.25M.25 8h17.5v10.625c0 1.055-.86 1.875-1.875 1.875H2.125A1.85 1.85 0 0 1 .25 18.625zm2.5 4.375c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625h-1.25a.64.64 0 0 0-.625.625zm5 0c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625h-1.25a.64.64 0 0 0-.625.625zm5.625-1.875a.64.64 0 0 0-.625.625v1.25c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625zM2.75 17.375c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625h-1.25a.64.64 0 0 0-.625.625zM8.375 15.5a.64.64 0 0 0-.625.625v1.25c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625zm4.375 1.875c0 .352.273.625.625.625h1.25a.64.64 0 0 0 .625-.625v-1.25c0-.312-.312-.625-.625-.625h-1.25a.64.64 0 0 0-.625.625z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }